import authStore from "./AuthStore";
import commonStore from "./CommonStore";

export default {
  authStore,
  commonStore
};
